module.exports = __webpack_public_path__ + "static/Giant_Fire-445cc4f55f5a4999f587a131caad67d7.jpg";